<template>
  <div class="payment_item">
    <!-- 显示部分账单 -->
    <div class="less" v-if="more">
      <h1>
        未缴费账单
        <a href="javascript:;" @click="showMore(true)">更多</a>
      </h1>
      <myTable :tableObj="tableObj1" @btnClick="btnClick" @changePageNo="getList"></myTable>
      <h1>
        已缴费账单
        <a href="javascript:;" @click="showMore(false)">更多</a>
      </h1>
      <myTable :tableObj="tableObj2" @btnClick="btnClick" @changePageNo="getList"></myTable>
    </div>
    <!-- 显示更多账单 -->
    <div class="more" v-else>
      <div class="unpay" v-if="more_unpay">
        <h1>
          未缴费账单
          <a href="javascript:;" @click="goBack">返回</a>
        </h1>
        <myTable :tableObj="tableObj1" @btnClick="btnClick" @changePageNo="getList(true)"></myTable>
      </div>
      <div class="paid" v-else>
        <h1>
          已缴费账单
          <a href="javascript:;" @click="goBack">返回</a>
        </h1>
        <myTable :tableObj="tableObj2" @btnClick="btnClick" @changePageNo="getList(false)"></myTable>
      </div>
    </div>
    <!-- 上传凭证弹窗 -->
    <el-dialog
      title="上传凭证"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div class="uploads">
        <el-form ref="form" label-width="150px">
          <el-form-item label="上传转账凭证：" :rules="[{required:true}]" prop="params1.coverPath">
            <uploadFile :params="params1" :apiParams="apiParams1"></uploadFile>
            <div class="tips tips1">
              <p>1.请上传转账记录凭证</p>
              <p>2.仅支持pdf格式</p>
              <a :href="params1.coverPath" target="_blank" v-if="params1.coverPath">查看附件</a>
            </div>
          </el-form-item>
          <el-form-item label="上传发票凭证：" :rules="[{required:true}]" prop="params1.coverPath">
            <uploadFile :params="params2" :apiParams="apiParams2"></uploadFile>
            <div class="tips tips2">
              <p>1.请上传发票凭证</p>
              <p>2.仅支持pdf格式</p>
              <a :href="params2.coverPath" target="_blank" v-if="params2.coverPath">查看附件</a>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click=" dialogVisible= false">取 消</el-button>
        <el-button type="primary" @click="upLoad">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myTable from "@/components/my_table";
import uploadFile from "@/components/file_upload/uploadFile.vue";
export default {
  components: {
    myTable,
    uploadFile
  },
  props: {
    // 未缴费账单列表数据
    tableObj1: {
      type: Object
    },
    // 已缴费账单列表数据
    tableObj2: {
      type: Object
    }
  },
  data() {
    return {
      more: true, //显示更多flag
      more_unpay: true, // 显示更多的已缴费或者未缴费flag
      dialogVisible: false,
      costId: "", //缴费记录id
      // form: {},
      params1: {
        coverPath: "",
        certificates: ""
      },
      params2: {
        coverPath: "",
        invoices: ""
      },
      apiParams1: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogUserHead"
        },
        size: 5, //文件大小
        type: "pdf", //类型 pdf ysb(压缩包包含rar和zip) zip rar
        imgPath: "coverPath", //文件路径字段
        fileId: "certificates" //文件id字段
      },
      apiParams2: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogUserHead"
        },
        size: 5, //文件大小
        type: "pdf", //类型 pdf ysb(压缩包包含rar和zip) zip rar
        imgPath: "coverPath", //文件路径字段
        fileId: "invoices" //文件id字段
      }
    };
  },
  methods: {
    btnClick(btn) {
      switch (btn.btnFuncName) {
        // case "toPay":
        //   break;
        // 上传凭证
        case "uploadCertificate":
          // console.log(btn.row.id);
          this.dialogVisible = true;
          this.costId = btn.row.id;
          break;
      }
    },
    // 点击分页页码触发查询
    getList(flag) {
      this.$emit("getList", flag);
    },
    //显示更多
    showMore(flag) {
      this.more = false;
      this.more_unpay = flag;
      this.tableObj1.layerpageinfo.hide = false;
      this.tableObj2.layerpageinfo.hide = false;
      this.tableObj1.layerpageinfo.pageSize = 7;
      this.tableObj2.layerpageinfo.pageSize = 7;
      // this.tableObj1.layerpageinfo.pageNo = 0;
      // this.tableObj2.layerpageinfo.pageNo = 0;
      this.$emit("getList", flag);
    },
    //返回
    goBack() {
      this.more = true;
      this.tableObj1.layerpageinfo.hide = true;
      this.tableObj2.layerpageinfo.hide = true;
      this.tableObj1.layerpageinfo.pageSize = 3;
      this.tableObj2.layerpageinfo.pageSize = 3;
      this.tableObj1.layerpageinfo.pageNo = 0;
      this.tableObj2.layerpageinfo.pageNo = 0;
      this.$emit("getList", true);
      this.$emit("getList", false);
    },
    // 上传凭证文件
    upLoad() {
      this.dialogVisible = true;
      let params = {
        id: this.costId,
        certificates: this.params1.certificates,
        invoices: this.params2.invoices,
        operation: "IdentityCertifieStatusInReview"
      };
      this.api.pay(params).then(res => {
        // console.log(res);
        if (res.error.err_code !== 0) return;
        this.$message.success("上传凭证成功");
        this.dialogVisible = false;
        Object.assign(this.$data.params1, this.$options.data().params1);
        Object.assign(this.$data.params2, this.$options.data().params2);
        this.$emit("getList", false); //触发父组件页面获取列表事件
        this.$emit("getList", true); //触发父组件页面获取列表事件
        this.params1.coverPath = "";
        this.params1.certificates = "";
        this.params2.coverPath = "";
        this.params2.invoices = "";
      });
    },
    //关闭dialog
    handleClose() {
      this.dialogVisible = false;
      Object.assign(this.$data.params1, this.$options.data().params1);
      Object.assign(this.$data.params2, this.$options.data().params2);
    }
  }
};
</script>
<style lang="scss">
.payment_item {
  padding: 10px;
  h1 {
    font-weight: 600;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    a {
      font-size: 13px;
      color: #117eff;
      font-weight: normal;
    }
  }
  .uploads {
    .el-form-item__content {
      // position: relative;
      display: flex;
      .uploadImg{
        width: 85px;
        .cover{
          width: 85px;
        }
      }
      .tips {
        margin-left: 20px;
        padding-top: 10px;
        top: 10px;
        font-size: 12px;
        color: #ccc;
        p {
          line-height: 20px;
        }
        a {
          color: #117eff;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>